import axios from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    transactionsTableItems: [],
    transactionsApplicationMeta: {},
    isTransactionsTableBusy: false,
    paymentContractsUpcomingTransactions: [],
    isModalLoaidng: false,
    applications: [],
    selectedApplication: null,
    chargesList: [],
    selectedCharges: [],
    paymentAmount: 0,
    paymentMethod: 'Credit Card',
    paymentMethodsList: ['Credit Card', 'ACH', 'Cash Bank'],
    cashBankBalance: 0,
    includeCashBank: false,
    statusModalTitle: '',
    statusModalStatus: '',
    statusModalHeader: '',
    statusModalMessage: '',
    familyId: null,
    paymentFees: [],
  },
  getters: {
    getTransactionsTableItems: state => state.transactionsTableItems,
    getTransactionsApplicationMeta: state => state.transactionsApplicationMeta,
    getIsTransactionsTableBusy: state => state.isTransactionsTableBusy,
    getPaymentContractsUpcomingTransactions: state => state.paymentContractsUpcomingTransactions,
    getIsModalLoaidng: state => state.isModalLoaidng,
    getApplications: state => state.applications,
    getSelectedApplication: state => state.selectedApplication,
    getChargesList: state => state.chargesList,
    getSelectedCharges: state => state.selectedCharges,
    getPaymentAmount: state => state.paymentAmount,
    getPaymentMethod: state => state.paymentMethod,
    getPaymentMethodsList: state => state.paymentMethodsList,
    getCashBankBalance: state => state.cashBankBalance,
    getIncludeCashBank: state => state.includeCashBank,
    getStatusModalTitle: state => state.statusModalTitle,
    getStatusModalStatus: state => state.statusModalStatus,
    getStatusModalHeader: state => state.statusModalHeader,
    getStatusModalMessage: state => state.statusModalMessage,
    getFamilyId: state => state.familyId,
    getPaymentFees: state => state.paymentFees,
  },
  mutations: {
    SET_TRANSACTIONS_TABLE_ITEMS: (state, val) => {
      state.transactionsTableItems = val
    },
    SET_TRANSACTIONS_APPLICATION_META: (state, val) => {
      state.transactionsApplicationMeta = val
    },
    SET_TRANSACTIONS_TABLE_BUSY_STATE: (state, val) => {
      state.isTransactionsTableBusy = val
    },
    SET_PAYMENT_CONTRACTS_UPCOMING_TRANSACTIONS: (state, val) => {
      state.paymentContractsUpcomingTransactions = val
    },
    SET_MODAL_LOADING_STATE: (state, val) => {
      state.isModalLoaidng = val
    },
    SET_APPLICATIONS: (state, val) => {
      state.applications = val
    },
    SET_SLECTED_APPLICATION: (state, val) => {
      state.selectedApplication = val
    },
    SET_CHARGES_LIST: (state, val) => {
      state.chargesList = val
    },
    SET_SELECTED_CHARGES: (state, val) => {
      state.selectedCharges = val
    },
    SET_PAYMENT_AMOUNT: (state, val) => {
      state.paymentAmount = val
    },
    SET_PAYMENT_METHOD: (state, val) => {
      state.paymentMethod = val
    },
    SET_CASH_BANK_BALANCE: (state, val) => {
      state.cashBankBalance = val
    },
    SET_INCLUDE_CASH_BANK_STATUS: (state, val) => {
      state.includeCashBank = val
    },
    SET_STATUS_MODAL_TITLE: (state, val) => {
      state.statusModalTitle = val
    },
    SET_STATUS_MODAL_STATUS: (state, val) => {
      state.statusModalStatus = val
    },
    SET_STATUS_MODAL_HEADER: (state, val) => {
      state.statusModalHeader = val
    },
    SET_STATUS_MODAL_MESSAGE: (state, val) => {
      state.statusModalMessage = val
    },
    SET_FAMILY_ID: (state, val) => {
      state.familyId = val
    },
    SET_PAYMENT_FEES: (state, val) => {
      state.paymentFees = val
    },
  },
  actions: {
    async fetchTransactionsList(store) {
      store.commit('SET_TRANSACTIONS_TABLE_BUSY_STATE', true)
      try {
        const response = await axios.get('/my-transactions')
        const transactionsPerApplications = {}
        const applicationMeta = {}

        response.data.data.forEach(item => {
          if (item.application_id) {
            if (transactionsPerApplications[item.application_id]) {
              transactionsPerApplications[item.application_id].push(item)
            } else {
              transactionsPerApplications[item.application_id] = [item]
            }
            // Store per-application PC notification meta (same values for whole group)
            if (!applicationMeta[item.application_id]) {
              applicationMeta[item.application_id] = {
                application_id: item.application_id,
                user_id:        item.application_user_id,
                program_id:     item.program_id,
                is_accepted:    item.is_accepted,
                has_pc:         item.has_pc,
                has_pc_step:    item.has_pc_step,
              }
            }
          }
        })
        store.commit('SET_TRANSACTIONS_TABLE_ITEMS', transactionsPerApplications)
        store.commit('SET_TRANSACTIONS_APPLICATION_META', applicationMeta)
      } catch (error) {
        console.error('Error fetching transactions list:', error)
        throw error
      } finally {
        store.commit('SET_TRANSACTIONS_TABLE_BUSY_STATE', false)
      }
    },
    async fetchUpcomingPayments(store) {
      try {
        const queryParams = {
          status: ['Pending', 'Payment Failed'],
        }
        const response = await axios.get('/pay-condition-transactions', { params: queryParams })

        const paymentContractsUpcomingPayments = response.data.data.filter(
          item => item.condition_type == 'PaymentOption'
        )

        store.commit('SET_PAYMENT_CONTRACTS_UPCOMING_TRANSACTIONS', paymentContractsUpcomingPayments)
      } catch (error) {
        console.error('Error fetching upcoming payments:', error)
        throw error
      }
    },
    async payUpcomingPaymentTransaction(store, payload) {
      try {
        await axios.post(`/pay-condition-transactions/${payload.id}/pay`, payload.params)
      } catch (error) {
        console.error('Error paying upcoming payment transaction:', error)
        throw error
      }
    },
    async fetchApplications(store, queryParams) {
      try {
        const response = await axios.get('/applications/for-select', { params: queryParams })
        store.commit('SET_APPLICATIONS', response.data.data)
      } catch (error) {
        console.error('Error fetching applications:', error)
        throw error
      }
    },
    async fetchTransactionCharges(store, queryParams) {
      try {
        const response = await axios.get('/my-transactions', { params: queryParams })
        const filteredCharges = response.data.data.filter(
          charge => charge.charge_remaining_sum !== 0 && charge.status === 'Completed'
        )
        store.commit('SET_CHARGES_LIST', filteredCharges)
      } catch (error) {
        console.error('Error fetching transaction charges:', error)
        throw error
      }
    },
    async sendNewTransaction(store, queryParams) {
      try {
        await axios.post('/transactions', queryParams)
      } catch (error) {
        console.error('Error sending new transaction:', error)
        throw error
      }
    },
    async fetchCashBankTransactions(store, queryParams) {
      try {
        return await axios.get('/my-transactions', { params: queryParams })
      } catch (error) {
        console.error('Error fetching cash bank transactions:', error)
        throw error
      }
    },
    async fetchCashBankBalance(store) {
      // Prefer the family ID already committed to the family module;
      // fall back to the one stored in userData (always available from localStorage).
      const familyId = store.rootState.family.familyId
        || store.rootState.userData?.family_id
        || null

      if (!familyId) {
        // No family ID means Cash Bank is not available for this user.
        store.commit('SET_CASH_BANK_BALANCE', 0)
        return
      }

      try {
        const response = await axios.post(`/family/${familyId}/balance`)
        store.commit('SET_CASH_BANK_BALANCE', response.data.data.amount)
      } catch (error) {
        console.error('Error fetching cash bank balance:', error)
        // Non-critical — default to 0 so the UI can still render
        store.commit('SET_CASH_BANK_BALANCE', 0)
      }
    },
    async fetchPaymentFees(store, programId) {
      try {
        const response = await axios.get('/payment-fees', { params: { program_id: programId } })
        store.commit('SET_PAYMENT_FEES', response.data.data || [])
      } catch (error) {
        console.error('Error fetching payment fees:', error)
        store.commit('SET_PAYMENT_FEES', [])
      }
    },
    async refreshData({ dispatch }) {
      try {
        await dispatch('fetchTransactionsList')
      } catch (error) {
        console.error('refreshData: fetchTransactionsList failed:', error)
      }

      try {
        await dispatch('fetchUpcomingPayments')
      } catch (error) {
        console.error('refreshData: fetchUpcomingPayments failed:', error)
      }

      try {
        await dispatch('fetchCashBankBalance')
      } catch (error) {
        console.error('refreshData: fetchCashBankBalance failed:', error)
      }
    },
  },
}